// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__22nEr","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3xcm0"};